import fetchJSON from "../fetchJSON"
import { BAD_REQUEST, TIMEOUT, UNEXPECTED_ERROR } from "../constants";

export function formatFastPassResponse(response: any, status: number): any {

  let data = null

  try {

    data = response.data

  } catch (error) {

    if (!response && !status) {
      return {
        status: 504,
        data: {
          message: TIMEOUT
        }
      }
    }

    return {
      status: status || 500,
      data: {
        message: (status === 400) ? BAD_REQUEST : UNEXPECTED_ERROR
      }
    }

  }

  return {
    status: response.status,
    data: data
  }

}

export interface FastPassProps {
  channelId: string,
  leadId: string
}

async function fetchFastPass(hostUrl = '', reqBody: FastPassProps): Promise<any> {

  try {

    const { data, status } = await fetchJSON('fetchFastPass', `${hostUrl || process.env.HOST}/webcast/api/fastpass`, {
      method: 'POST',
      body: JSON.stringify(reqBody),
      timeout: 7000,
      includeCredentials: true
    })

    return formatFastPassResponse(data, status);

  } catch (error) {

    return {}

  }

}

export default fetchFastPass